import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { GeneralWarningModalComponent } from "../../../components/shared/modals/general-warning-modal/general-warning-modal.component";
import { ErrorMessageService } from "../../../services/error-message.service";
import { base64ToFile, ImageCroppedEvent } from "ngx-image-cropper";
import { badge } from "../../../components/accreditation/evaluator-management/add-evaluator-candidate/add-evaluator-candidate.component";
import {DomSanitizer} from "@angular/platform-browser";

@Component({
    selector: 'app-upload',
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.scss'],
    standalone: false
})
export class UploadComponent implements OnInit {

  imageChangedEvent: Event | null = null;
  croppedImage: any = '';
  fileName: string;

  uploadingNew: boolean = false;

  constructor(
    private errorMessage: ErrorMessageService,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<GeneralWarningModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      title: string | "Upload file",
      cancelText: string | "Cancel",
      confirmText: string | "OK",
      file: any,
      base64: any,
      badges: badge[],
      selectedBadge: badge,
      isNew: boolean,
      fileName: string,
      roundCropper: boolean,
    }
  ) {}

  ngOnInit() {
    this.data.isNew = false;
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  uploadFile(event: Event) {
    console.log(event)
    this.data.isNew = true;
    this.uploadingNew = true;
    this.handleTheUpload(event);
  }

  dropFile(files: FileList) {
    if(files.length > 0) {
      this.data.isNew = true;
      this.uploadingNew = true;
      const imageChangedEvent = {
        target: {
          files: files
        }
      } as any;
      this.handleTheUpload(imageChangedEvent);
    }
  }

  handleTheUpload(event:Event) {
    const input = event.target as HTMLInputElement;
    const file:File = input.files?.[0];
    const fileType = file?.type;
    const validImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
    const nonLatinRegex = /[^\u0000-\u007f]/;
    if (!validImageTypes.includes(fileType)) {
      this.errorMessage.showErrorModal("Invalid File", [{description: file.name + ' is not a valid image file. Please select a file type .png or .jpg.'}]);
    }
    else if (nonLatinRegex.test(file.name)) {
      this.errorMessage.showErrorModal("Invalid File", [{description: file.name + ' is not a valid filename. Please rename the file to contain only latin characters, numbers, and symbols. Then try to upload the file again.'}]);
    } else if (file.name.length > 100) {
      this.errorMessage.showErrorModal("Invalid File", [{description: file.name + ' is not a valid filename because it contains more than 100 characters. Please rename the file to contain less than 100 characters. Then try to upload the file again.'}]);
    }
    else {
      //return file
      this.data.file = file;
      this.fileName = file.name;
      //this.dialogRef.close(this.data.file);
     this.imageChangedEvent = event;
    }
  }

  fileChangeEvent(event: any): void {
    this.uploadingNew = true;
    this.imageChangedEvent = event;
  }
  imageCropped(event: ImageCroppedEvent) {
    this.data.base64 = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl);
    this.croppedImage = this.blobToFile(event.blob, this.fileName, 'image/png');
    this.data.file = this.croppedImage;
    this.data.fileName = this.fileName;
  }
  imageLoaded() {
    // show cropper
  }
  cropperReady() {
    // cropper ready
  }
  loadImageFailed() {
    // show message
  }

  blobToFile(blob: Blob, fileName: string, mimeType?: string): File {
    return new File([blob], fileName, {
      type: mimeType || blob.type || 'application/octet-stream',
      lastModified: Date.now(),
    });
  }

  removeImage() {
    this.data.file = null;
    this.data.isNew = true;
  }

  choseBadge(badge:badge) {
    this.data.selectedBadge = badge;
  }

  submit(){
   this.dialogRef.close(this.data);
  }
}
